module.exports = __webpack_public_path__ + "img/bg_figure4.2e152b5a.png";